<template>
  <g>
    <eco2-volume1 />
    <eco2-volume2 />
    <eco2-volume3 />
    <eco2-volume4 />
    <eco2-volume5 />
    <eco2-volume6 />
    <eco2-volume7 />
    <eco2-volume8 />
    <eco2-volume9 />
    <eco2-volume10 />
    <eco2-volume11 />
    <eco2-volume12 />
    <eco2-volume13 />
    <eco2-volume14 />
    <eco2-volume15 />
    <eco2-volume16 />
    <eco2-volume17 />
  </g>
</template>

<script>
import eco2Volume1 from "./eco2/volume1.vue";
import eco2Volume2 from "./eco2/volume2.vue";
import eco2Volume3 from "./eco2/volume3.vue";
import eco2Volume4 from "./eco2/volume4.vue";
import eco2Volume5 from "./eco2/volume5.vue";
import eco2Volume6 from "./eco2/volume6.vue";
import eco2Volume7 from "./eco2/volume7.vue";
import eco2Volume8 from "./eco2/volume8.vue";
import eco2Volume9 from "./eco2/volume9.vue";
import eco2Volume10 from "./eco2/volume10.vue";
import eco2Volume11 from "./eco2/volume11.vue";
import eco2Volume12 from "./eco2/volume12.vue";
import eco2Volume13 from "./eco2/volume13.vue";
import eco2Volume14 from "./eco2/volume14.vue";
import eco2Volume15 from "./eco2/volume15.vue";
import eco2Volume16 from "./eco2/volume16.vue";
import eco2Volume17 from "./eco2/volume17.vue";

export default {
  components: {
    eco2Volume1,
    eco2Volume2,
    eco2Volume3,
    eco2Volume4,
    eco2Volume5,
    eco2Volume6,
    eco2Volume7,
    eco2Volume8,
    eco2Volume9,
    eco2Volume10,
    eco2Volume11,
    eco2Volume12,
    eco2Volume13,
    eco2Volume14,
    eco2Volume15,
    eco2Volume16,
    eco2Volume17,
  },
};
</script>



// WEBPACK FOOTER //
// eco2.vue?2b72a438